import Vue from 'vue'
import Router from 'vue-router'
import routes from './routers'
// import { getToken } from '@/libs/util'
Vue.use(Router)

const identifier = 'fintech2/'
const getBasePath = () => {
  const path = location.pathname
  return path.substr(0, path.lastIndexOf(identifier) + identifier.length)
}

const router = new Router({
  routes,
  mode: 'history',
  base: getBasePath()
})
/**
 * 未登录且要跳转的页面不是登录页,跳转到登录页
 * 未登陆且要跳转的页面是登录页,跳转往下走
 * 已登录且要跳转的页面是登录页，跳转到主界面页
 * 已登录且要跳转的页面不是登录页，跳到该跳的页面
 */
router.beforeEach((to, from, next) => {
  next()
  // const token = getToken()
  // if (!token && to.name !== 'login') {
  //   next({name: 'login'})
  // } else if (!token && to.name === 'login') {
  //   next()
  // } else if (token && to.name === 'login') {
  //   next({name: 'home'})
  // } else {
  //   next()
  // }
})
// 跳转后拦截
router.afterEach((to, from, next) => {
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js